// extracted by mini-css-extract-plugin
export default {"table-container":"M_TKiYZs1hzC2p4Emhjd","table-top-right-field":"IBUnqEmgmJDfzrAbdBXi","table-wrapper":"zUPyp5wpGKsVW5N41mQg"};